import { ILoginData, Auth } from 'Auth';

export class BaseAuthFormModelSender {
  send(authMethod: 'login', args: string[]): Promise<ILoginData> {
    return Auth[authMethod](args[0], args[1]);
  }
}
